module.exports = __webpack_public_path__ + "img/BLA-01-10.bbf49921.svg";